import { TOOL_TYPES, TOOL_CATEGORIES, getToolsByCategory } from '../store/useToolStore';
import { getCanonicalSeoPathForToolType } from './toolSlugs';

const getToolPath = (toolType) => getCanonicalSeoPathForToolType(toolType);

export const TOOL_DISPLAY_BY_TYPE = {
  [TOOL_TYPES.LOADER]: {
    path: getToolPath(TOOL_TYPES.LOADER),
    icon: '⚙️',
    name: 'Loader Generator',
    footerName: 'Loader Generator',
    description: 'Create animated loading indicators',
  },
  [TOOL_TYPES.GRADIENT]: {
    path: getToolPath(TOOL_TYPES.GRADIENT),
    icon: '🌈',
    name: 'Gradient Generator',
    footerName: 'Gradient Generator',
    description: 'Design beautiful gradients',
  },
  [TOOL_TYPES.CARD]: {
    path: getToolPath(TOOL_TYPES.CARD),
    icon: '🪪',
    name: 'Card Generator',
    footerName: 'Card Generator',
    description: 'Build reusable card components',
  },
  [TOOL_TYPES.ANIMATION]: {
    path: getToolPath(TOOL_TYPES.ANIMATION),
    icon: '⚡',
    name: 'Animation Generator',
    footerName: 'Animation Generator',
    description: 'Create smooth animations',
  },
  [TOOL_TYPES.ALERT]: {
    path: getToolPath(TOOL_TYPES.ALERT),
    icon: '🔔',
    name: 'Alert Generator',
    footerName: 'Alert Generator',
    description: 'Custom alert dialogs',
  },
  [TOOL_TYPES.PHOTO_PICKER]: {
    path: getToolPath(TOOL_TYPES.PHOTO_PICKER),
    icon: '📸',
    name: 'Photo Picker',
    footerName: 'Photo Picker Generator',
    description: 'Camera & library integration',
  },
  [TOOL_TYPES.SHADOW]: {
    path: getToolPath(TOOL_TYPES.SHADOW),
    icon: '🕶️',
    name: 'Shadow Generator',
    footerName: 'Shadow Generator',
    description: 'Generate .shadow() modifiers',
  },
  [TOOL_TYPES.BUTTON]: {
    path: getToolPath(TOOL_TYPES.BUTTON),
    icon: '🔘',
    name: 'Button Builder',
    footerName: 'Button Builder',
    description: 'Build styled SwiftUI buttons',
  },
  [TOOL_TYPES.GRID]: {
    path: getToolPath(TOOL_TYPES.GRID),
    icon: '🧩',
    name: 'Grid Generator',
    footerName: 'Grid Generator',
    description: 'Generate LazyVGrid layouts',
  },
  [TOOL_TYPES.PALETTE]: {
    path: getToolPath(TOOL_TYPES.PALETTE),
    icon: '🎨',
    name: 'Color Palette',
    footerName: 'Color Palette Generator',
    description: 'Generate named SwiftUI colors',
  },
  [TOOL_TYPES.JSON_TO_MODEL]: {
    path: getToolPath(TOOL_TYPES.JSON_TO_MODEL),
    icon: '🔍',
    name: 'JSON to Codable',
    footerName: 'JSON to Codable Generator',
    description: 'Convert JSON to Swift models',
  },
  [TOOL_TYPES.API_GENERATOR]: {
    path: getToolPath(TOOL_TYPES.API_GENERATOR),
    icon: '🌐',
    name: 'API Generator',
    footerName: 'API Generator',
    description: 'Generate API client code',
  },
  [TOOL_TYPES.POSTMAN_IMPORTER]: {
    path: getToolPath(TOOL_TYPES.POSTMAN_IMPORTER),
    icon: '📝',
    name: 'Postman to Code',
    footerName: 'Postman to Code Generator',
    description: 'Postman to Swift, Node, Python, cURL',
  },
  [TOOL_TYPES.JSON_FORMATTER]: {
    path: getToolPath(TOOL_TYPES.JSON_FORMATTER),
    icon: '📋',
    name: 'JSON Formatter',
    footerName: 'JSON Formatter',
    description: 'Format and beautify JSON online',
  },
  [TOOL_TYPES.BASE64]: {
    path: getToolPath(TOOL_TYPES.BASE64),
    icon: '🔐',
    name: 'Base64 Tool',
    footerName: 'Base64 Encoder Decoder',
    description: 'Encode and decode Base64',
  },
};

export const CATEGORY_CONFIG = [
  {
    id: TOOL_CATEGORIES.SWIFTUI,
    label: 'SwiftUI Generators',
    description: 'Visual SwiftUI components with live preview — loaders, gradients, cards, and more.',
  },
  {
    id: TOOL_CATEGORIES.DEVELOPER,
    label: 'Developer Tools',
    description: 'Format JSON, encode and decode Base64, and work with data in the browser.',
  },
  {
    id: TOOL_CATEGORIES.SWIFT,
    label: 'Swift & API Tools',
    description: 'Generate models, API clients, and code from Postman collections.',
  },
];

const HIDDEN_TOOL_TYPES = new Set([TOOL_TYPES.STORYBOARD_CONVERTER]);

const buildCategoryTools = (categoryId) =>
  getToolsByCategory(categoryId)
    .filter((toolType) => !HIDDEN_TOOL_TYPES.has(toolType))
    .map((toolType) => {
      const display = TOOL_DISPLAY_BY_TYPE[toolType];
      if (!display?.path) return null;
      return { toolType, ...display };
    })
    .filter(Boolean);

export const getToolsGroupedByCategory = () => ({
  [TOOL_CATEGORIES.SWIFTUI]: buildCategoryTools(TOOL_CATEGORIES.SWIFTUI),
  [TOOL_CATEGORIES.DEVELOPER]: buildCategoryTools(TOOL_CATEGORIES.DEVELOPER),
  [TOOL_CATEGORIES.SWIFT]: buildCategoryTools(TOOL_CATEGORIES.SWIFT),
});
